module.exports = __webpack_public_path__ + "static/img/ld-pz12.6393678.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ld-pz12.png
// module id = sUpB
// module chunks = 1